<template>
  <p class="text-view" :class="type" @mouseout="onMouseout">
    <span v-if="type === 'copy'" class="copy-text-box" @click="onClick">
      <el-tooltip effect="dark" :content="copyTips" placement="top" popper-class="text-popper">
        <span>
          <span class="copy-text">{{ text }}</span>
          <i class="iconfont icon-fuzhi margin-left-5"></i>
        </span>
      </el-tooltip>
    </span>
    <span v-else-if="type === 'link'" @click="onClick">
      <span class="link-text">{{ text }}</span>
    </span>
    <span v-else-if="type === 'blank_link'">
      <span class="text">{{ text }}</span>
      <span class="blank-link-text margin-left-4" @click="onClick">
        <i class="desc">{{ desc }}</i><img class="icon margin-left-3" src="@/assets/images/base/icon-link.png" />
      </span>
    </span>
    <span v-else-if="type === 'emphasize'">
      <span class="text emphasize">{{ text }}</span>
    </span>
    <span v-else>
      <span class="text">{{ text }}</span>
    </span>
  </p>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'normal',
    },
    text: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      copyTips: this.$t('message.common.copy'),
    };
  },
  methods: {
    async onClick() {
      if (this.type === 'copy') {
        await this.$copyText(this.text);
        this.copyTips = this.$t('message.common.copied');
      } else if (this.type === 'link' || this.type === 'blank_link') {
        this.$emit('link');
      }
    },
    onMouseout() {
      this.copyTips = this.$t('message.common.copy');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.text-view {
  display: flex;
  align-items: center;
  font-family: Urbanist-Medium;

  .copy-text-box {
    cursor: pointer;

    &:hover {
      .copy-text {
        border-bottom: 1px solid $color-primary-new;
      }
    }
  }

  .link-text {
    cursor: pointer;
    // text-decoration: underline dotted;
    // text-underline-offset: 2px;
    border-bottom: 1px dashed #667085;

    &:hover {
      // text-decoration: underline;
      // text-decoration-color: $color-primary-new;
      border-bottom: 1px solid $color-primary-new;
    }
  }

  .blank-link-text {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    font-weight: 400;
    font-size: 12px;
    color: #667085;
    line-height: 16px;
    border-bottom: 1px dashed #667085;
    font-style: normal;

    i {
      font-style: normal;
    }

    &:hover {
      border-bottom: 1px solid $color-primary-new;
    }

    .icon {
      width: 12px;
      height: 12px;
    }
  }

  .emphasize {
    color: $color-primary-new;
  }
}
</style>
<style lang="scss">
.text-popper {
  .popper__arrow {
    left: 50% !important;
    transform: translateX(-50%);
  }
}
</style>
